import { render, staticRenderFns } from "./Licences.vue?vue&type=template&id=5151afa0"
import script from "./Licences.vue?vue&type=script&lang=ts"
export * from "./Licences.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports